var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('strong',[_vm._v("Payment Overdue! ")]),_vm._v("Your account has overdue invoices. Please reach out to us to resolve this issue to avoid disruption in service.")])
}]

export { render, staticRenderFns }